import { ContactsOrderBy, ContactStatus } from '@dev/ee-api/ee-api-models';
import { SyntheticEvent, useCallback } from 'react';

import { debounce } from '@/services/tools/debounce';

import { useContactQueryParams } from './useContactQueryParams';

export const useFilterActions = () => {
    const { queryOrderBy, pushParamToUrl } = useContactQueryParams();

    const sortByAddDate = useCallback(() => {
        const newOrder =
            !queryOrderBy || queryOrderBy === ContactsOrderBy.DateAddedAsc
                ? ContactsOrderBy.DateAddedDesc
                : ContactsOrderBy.DateAddedAsc;
        pushParamToUrl({ orderBy: newOrder });
    }, [queryOrderBy]);

    const sortByUpdateDate = useCallback(() => {
        const newOrder =
            !queryOrderBy || queryOrderBy === ContactsOrderBy.DateUpdatedAsc
                ? ContactsOrderBy.DateUpdatedDesc
                : ContactsOrderBy.DateUpdatedAsc;
        pushParamToUrl({ orderBy: newOrder });
    }, [queryOrderBy]);

    const onStatusFilterClick = useCallback(
        (event: SyntheticEvent<HTMLInputElement>, selectedItems: ContactStatus[]): void => {
            debounce(() => {
                pushParamToUrl({ statuses: selectedItems });
            }, 1000);
        },
        []
    );

    return {
        sortByAddDate,
        sortByUpdateDate,
        onStatusFilterClick,
    };
};
